import React from 'react'
import "./Confucius.css"
import { renderStatementWithKaTeX } from '../../../../../Functions/WriteLaTex'
import ConfuciusGame from './ConfusiusGame/ConfuciusGame'


const Confucius = () => {
    const Statement=`There are $2026$ integers greater than $1$ written on a blackboard, not necessarily different. In a move, Confucius chooses two integers $m>1$ and $n>1$ from different places on the blackboard and replaces these two integers with
$$
\\gcd(m,n)
\\qquad\\text{and}\\qquad
\\frac{\\operatorname{lcm}(m,n)}{\\gcd(m,n)}.
$$
He continues to make moves while it is possible to do so.

(a) Prove that, regardless of the choices of Confucius, after finitely many moves, exactly one integer $M$ on the blackboard is greater than $1$.
(b) Prove that the value of $M$ does not depend on the choices of Confucius.
(Note that $\\gcd(x,y)$ denotes the greatest common divisor of positive integers $x$ and $y$, and $\\operatorname{lcm}(x,y)$ denotes the least common multiple of $x$ and $y$.)`
  return (
    <div className='Game'>
      <div className='discription'>
              <h1> IMO 2026 Problem 1 : Confucius </h1>
             
               <h2>- Problem Statement -</h2>
               <div className='Statement'>
                 
                    <div className='StatementParts'>
                       { renderStatementWithKaTeX(Statement)}
                  
                    </div>
                    
                    
               </div>
            

            </div>
            
<h1 className='ChangeValue-comment'>+ 2026 is too too large, try working with 6 integers +</h1>
    <ConfuciusGame/>
    </div>
  )
}

export default Confucius
